import React, { useState, useEffect, useCallback } from "react";

import { useFormik } from "formik";

import { useRecoilValue, useSetRecoilState } from "recoil";
import { userCredentials, routeInfo } from "recoilState/GlobalState";

import { migraPasoGet, migraVueloGet } from "services/services-mia/migra";
import { useService } from "components/route/ServiceRoute";

import XGridServer from "components/UI/Grid/XGridServer";
import Filters from "components/Filters";
import Modal from "components/UI/Modal/Modal";
import { Buttons, HeaderButton } from "components";
import { VueloDetalleModal, VueloPasajerosModal } from "./Actions";

import FilterAltOffRoundedIcon from "@mui/icons-material/FilterAltOffRounded";
import { Cached, AirplanemodeActiveRounded, GroupsOutlined } from "@mui/icons-material";

import { Routes } from "consts/Routes-App";
import { migraVueloColumns, mapMigraVueloRow } from "pages/migra/utils/vuelo";

import s from "styles/pages/Pages.module.scss";

const TIPO_OPTIONS = [
    { cod: "", nombre: "Todos" },
    { cod: "E", nombre: "Entrada" },
    { cod: "S", nombre: "Salida" },
];

export default function Vuelos() {
    const [rowSelected, setRowSelected] = useState({ status: false, row: {} });
    const [forceUpload, setForceUpload] = useState(false);
    const [modalDetalle, setModalDetalle] = useState({ isOpen: false });
    const [modalPasajeros, setModalPasajeros] = useState({ isOpen: false });
    const [pasos, setPasos] = useState([]);

    const { service } = useService();
    const credentials = useRecoilValue(userCredentials);
    const setRoute = useSetRecoilState(routeInfo);

    const updateList = useCallback(() => {
        setForceUpload(Date.now());
    }, []);

    const formik = useFormik({
        initialValues: {
            fecha: "",
            paso: "",
            tipo: "",
        },
        onSubmit: () => updateList(),
    });

    const resetFilters = () => {
        formik.resetForm();
        updateList();
    };

    const getRows = async (page, pageSize) => {
        const { result, total } = await migraVueloGet(
            {
                migraPasoId: formik.values.paso || null,
                migraVueloTipo: formik.values.tipo || null,
                migraVueloFecha: formik.values.fecha || null,
                page: page + 1,
                pageSize,
            },
            credentials
        );

        const rows = (result || []).map(mapMigraVueloRow);

        return { rows, rowCount: total };
    };

    useEffect(() => {
        setRoute(Routes.migraVueloTable);
    }, [setRoute]);

    useEffect(() => {
        if (!credentials?.merchantId) return;

        (async () => {
            const { result } = await migraPasoGet({}, credentials);
            setPasos((result || []).filter((paso) => paso.migraPasoStatus !== "B"));
        })();
    }, [credentials]);

    useEffect(() => {
        if (!credentials?.merchantId || !service) return;
        updateList();
    }, [service, credentials, updateList]);

    const closeDetalleModal = () => setModalDetalle({ isOpen: false });
    const closePasajerosModal = () => setModalPasajeros({ isOpen: false });

    return (
        <main className={s.main}>
            <Modal
                open={modalDetalle.isOpen}
                title="Detalle del Vuelo"
                onClose={closeDetalleModal}
                wide
            >
                {modalDetalle.isOpen && (
                    <VueloDetalleModal
                        row={rowSelected.row}
                        updateList={updateList}
                        closeModal={closeDetalleModal}
                        credentials={credentials}
                        setRowSelected={setRowSelected}
                        mostrarPasajeros={false}
                    />
                )}
            </Modal>
            <Modal
                open={modalPasajeros.isOpen}
                title="Pasajeros del Vuelo"
                onClose={closePasajerosModal}
                wide
            >
                {modalPasajeros.isOpen && (
                    <VueloPasajerosModal
                        row={rowSelected.row}
                        credentials={credentials}
                    />
                )}
            </Modal>
            <div className={s["filters-actions"]}>
                <div style={{ display: "flex", alignItems: "center" }}>
                    <Filters
                        formik={formik}
                        inputsRender={[
                            { type: "date", name: "fecha", label: "Fecha", disabled: false },
                            {
                                type: "select",
                                name: "paso",
                                label: "Paso",
                                options: [{ migraPasoId: "", migraPasoNombre: "Todos" }, ...pasos],
                                firstOptionKey: "migraPasoId",
                                firstOptionValue: "migraPasoId",
                                firstOptionName: "migraPasoNombre",
                                disabled: false,
                            },
                            {
                                type: "select",
                                name: "tipo",
                                label: "Tipo",
                                options: TIPO_OPTIONS,
                                firstOptionKey: "cod",
                                firstOptionName: "nombre",
                                firstOptionValue: "cod",
                                disabled: false,
                            },
                        ]}
                    />
                    <HeaderButton text={"Limpiar filtros"} onClick={resetFilters}>
                        <FilterAltOffRoundedIcon />
                    </HeaderButton>
                </div>
                <Buttons>
                    <HeaderButton text="Refrescar" onClick={updateList}>
                        <Cached />
                    </HeaderButton>
                    <HeaderButton
                        text="Ver detalle"
                        onClick={() => setModalDetalle({ isOpen: true })}
                        disabled={!rowSelected.row.id}
                    >
                        <AirplanemodeActiveRounded />
                    </HeaderButton>
                    <HeaderButton
                        text="Ver pasajeros"
                        onClick={() => setModalPasajeros({ isOpen: true })}
                        disabled={!rowSelected.row.id}
                    >
                        <GroupsOutlined />
                    </HeaderButton>
                </Buttons>
            </div>
            <div className={s.container}>
                <XGridServer
                    titles={migraVueloColumns}
                    updateList={getRows}
                    forceUpload={forceUpload}
                    secondarySelected={rowSelected}
                    setSecondarySelected={setRowSelected}
                />
            </div>
        </main>
    );
}
